import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { defaultTab: { type: String, default: "overview" } }

  connect() {
    const params = new URLSearchParams(window.location.search)
    const tab = params.get("tab")
    const hash = window.location.hash.replace("#", "")
    const initial = tab || hash || this.defaultTabValue

    if (tab) {
      // Clean the query param from the URL
      params.delete("tab")
      const clean = params.toString()
      const path = window.location.pathname + (clean ? `?${clean}` : "") + (tab ? `#${tab}` : "")
      history.replaceState(null, "", path)
    }

    this.select(null, initial)

    this.handleHashChange = () => {
      const hash = window.location.hash.replace("#", "")
      if (hash) this.select(null, hash)
    }
    window.addEventListener("hashchange", this.handleHashChange)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.handleHashChange)
  }

  select(event, tabName = null) {
    const name = tabName || event.currentTarget.dataset.tabsTabParam

    this.tabTargets.forEach(tab => {
      tab.classList.toggle("tab-active", tab.dataset.tabsTabParam === name)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tabsPanelParam !== name)
    })

    if (!tabName) {
      history.replaceState(null, "", `#${name}`)
    }
  }
}
